import React, { useMemo } from 'react';
import { Navigate, useParams } from 'react-router';

import ScrollableMobileCenteredBox from 'components/basic/panels/ScrollableMobileCenteredBox';
import { useSelectorActiveChain } from 'components/hooks';
import HeaderMobile from 'components/layout/header/HeaderMobile';
import MetaTags from 'components/layout/header/MetaTags';
import { getDashboardUrl } from 'reduxState/markets/listed/listedMarketsUtils';
import { useSelector } from 'reduxState/store';

import { sanitizeExternalMarketSymbol } from '../marketUtils';

import MarketDetailsWidget from './MarketDetailsWidget';

function MarketDetailsPage() {
  const isMobile = useSelector(state => state.screen.isMobile);
  const { activeChain } = useSelectorActiveChain();
  const defaultMarket = useSelector(
    state => state.markets.listedMarkets.defaultMarket
  );
  const { marketPairRaw } = useParams<{ marketPairRaw: string }>();

  const [base, quote] = useMemo(() => {
    const [base, quote] = marketPairRaw?.split('-') || [];
    return [
      sanitizeExternalMarketSymbol(base),
      sanitizeExternalMarketSymbol(quote),
    ];
  }, [marketPairRaw]);

  return !isMobile ? (
    <Navigate
      to={getDashboardUrl(activeChain, marketPairRaw, defaultMarket) || '/'}
    />
  ) : (
    <>
      <MetaTags title="Market Details" />
      <HeaderMobile chainLogo backGoTo="/">
        Market Details ({base}-{quote})
      </HeaderMobile>
      <ScrollableMobileCenteredBox>
        <div>
          <MarketDetailsWidget base={base} quote={quote} />
        </div>
      </ScrollableMobileCenteredBox>
    </>
  );
}

export default MarketDetailsPage;
